import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import Interpret from "./Localization/Interpret";

class BoxTerminal extends Component {
	render({className, style, title, subtitle, contentHeaderTitle, contentHeaderSlot, contentHeaderLeftSlot, contentHeaderRightSlot, contentLeftSlot, helperSlot, contentSlot, contentRightSlot}) {
		return (
			<section className={combineClasses("box-terminal", className)} style={style}>
				<header className={"title"}>
					<h1><Interpret id={title}/></h1>
					<p><Interpret id={subtitle}/></p>
				</header>

				<div className={"content-header-title"}>
					<Interpret id={contentHeaderTitle}/>
				</div>

				<div className={"content-header-left"}>
					{contentHeaderLeftSlot}
				</div>

				<div className={"content-header"}>
					<hr/>

					{contentHeaderSlot}
				</div>

				<div className={"content-header-right"}>
					{contentHeaderRightSlot}
				</div>

				<div className={"content-left"}>
					{contentLeftSlot}

					<div className={"help"}>
						{helperSlot}
					</div>
				</div>


				<div className={"content"}>
					{contentSlot}
				</div>

				<div className={"content-right"}>
					{contentRightSlot}
				</div>
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			title: PropTypes.string.isRequired,
			subtitle: PropTypes.string,
			contentHeaderTitle: PropTypes.string,
			contentHeaderSlot: PropTypes.any,
			contentHeaderLeftSlot: PropTypes.any,
			contentHeaderRightSlot: PropTypes.any,
			helperSlot: PropTypes.any,
			contentLeftSlot: PropTypes.any,
			contentSlot: PropTypes.any.isRequired,
			contentRightSlot: PropTypes.any,
		}
	}
}

export default BoxTerminal;
